module.exports = __webpack_public_path__ + "static/media/UGC.6e69ecb3.png";